import PropTypes from 'prop-types';

export default PropTypes.shape({
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  name: PropTypes.string.isRequired,
});
